import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import React, { useState, useEffect } from "react"

import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

// 로그인
import { getCode, login } from "../../crud/auth.crud"
import store from 'store';
import { SET_CODE } from 'store/auth/data/actionTypes';

// Redux
import { connect } from "react-redux"
import { withRouter, Link, useHistory } from "react-router-dom"
import { useSelector } from 'react-redux';

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// actions
import { loginUser, apiError } from "../../store/actions"

// import images
import loginLogo from "assets/images/login_logo.png"
import logoSm from "../../assets/images/logo-sm.png";
import weaver from "../../assets/images/weaver.png";
import { ReactComponent as Lock } from 'assets/images/svg/lock.svg';
import { ReactComponent as Person } from 'assets/images/svg/person.svg';

const Login = props => {
  const [userId, setUserId] = useState('e0')
  const [password, setPassword] = useState('qwer1234')
  const [isIdFocus, setIsIdFocus] = useState(false)
  const [isPwFocus, setIsPwFocus] = useState(false)
  const selector = useSelector(state => state)
  const history = useHistory()
  // handleValidSubmit
  const handleValidSubmit = (event, values) => {    
    // const url = {
    //   pathname : `/dashboard`,
    //   // state : {...prevState, ...values} 
    // }
    // if(memberId && values.memberPassword == values.memberPasswordConfirm){
    //   history.push(url);   
    // }
  }

  const checkLogin = async ()=>{
    const params = {
      user_id : userId,
      password : password,
    }
    const rs = await login(params)
    if(rs.data?.result === 'success'){
      props.loginUser(rs.data?.data, props.history)
      const response = await getCode()
      store.dispatch({ type: SET_CODE, data: [response.data]})
    }else{
      alert('아이디 또는 비밀번호가 일치하지 않습니다.') 
    }    
  }
  const [isLogin, setIsLogin] = useState(false);

  useEffect(()=>{    
    const loginData = localStorage.getItem('authUser');
    if(loginData){
        history.push('/dashboard')
    }    
  },[isLogin])

  return (
    <React.Fragment>
      <MetaTags>
        <title>로그인 | 웨이스트버스</title>
      </MetaTags>
      <div className='col-12 vh-100 position-fixed'>
        <div className="account-pages">
          <Container className='inset-0' style={{height: 425}}>
            <img src={loginLogo} className='mx-auto d-block mb-5 pointer' onClick={()=>{history.push('/')}} />
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={4}>
                <Card className="overflow-hidden">

                  <CardBody className="p-4">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={(e, v) => {
                          handleValidSubmit(e, v)
                        }}
                      >
                        {props.error && typeof props.error === "string" ? (
                          <Alert color="danger">{props.error}</Alert>
                        ) : null}

                        <div className="mb-2 loginInput position-relative">
                          <AvField
                            name="userId"
                            value={userId}
                            className="form-control"
                            placeholder="아이디를 입력해주세요."
                            type="text"
                            required
                            onChange={(e) => {
                              setUserId(e.target.value)
                            }}
                            onFocus={()=>{setIsIdFocus(true)}}
                            onBlur={()=>{setIsIdFocus(false)}}
                          />
                          <Person className='input-icon' fill={isIdFocus ? '#333333' : '#8A8A8A'} />
                        </div>

                        <div className="mb-4 loginInput position-relative">
                          <AvField
                            name="password"
                            value={password}
                            type="password"
                            required
                            placeholder="비밀번호를 입력해주세요."
                            onChange={(e) => {
                              setPassword(e.target.value)
                            }}
                            onFocus={()=>{setIsPwFocus(true)}}
                            onBlur={()=>{setIsPwFocus(false)}}
                          />
                          <Lock className='input-icon' fill={isPwFocus ? '#333333' : '#8A8A8A'} />
                        </div>

                        <Col sm={12}>
                          <button
                            className="btn btn-primary w-md waves-effect waves-light w-100 font-size-16"
                            type="submit"
                            onClick={() => {checkLogin()}}
                          >                            
                            로그인
                          </button>
                        </Col>

                        <Row className="mb-3 mt-2">
                          <Col xs={6}>
                            <div className="col-6">
                              <Link to="/select-type">
                                회원가입
                              </Link>
                            </div>
                            {/* <div className="form-check">
                              <input type="checkbox" className="form-check-input" id="customControlInline" />
                              <label className="form-check-label" htmlFor="customControlInline">아이디 기억하기</label>
                            </div> */}
                          </Col>
                          <Col xs={6} className="text-end">
                            <Link to="/forgot-password">
                              <i className="mdi mdi-lock"></i> 아이디/비밀번호 찾기
                            </Link>
                          </Col>
                        </Row>
                        <Row className="mt-2 mb-0 row">
                        </Row>
                        
                      </AvForm>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center text-silver font-size-12">
                  <p>
                    © {new Date().getFullYear()} Wasteverse
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const { error } = state.auth
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
)

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
}